import React from 'react';
import { VictoryChart, VictoryAxis, VictoryArea, VictoryVoronoiContainer, VictoryTooltip, VictoryLabel } from 'victory';

export const PointsDistribution = ({ data, pointTooltip, tickValues, tickFormat }) => {
  const canDrawChart = data && data.filter(item => item.y > 0).length > 1;

  return (
    canDrawChart &&
    <div className="chart-container">
      <VictoryChart style={{ parent: { backgroundColor: '#f0f7f8' } }}
                    containerComponent={<VictoryVoronoiContainer/>}>
        <VictoryArea data={data} labels={pointTooltip}
                     labelComponent={ <VictoryTooltip style={{ fontSize: 14 }} /> }
                     style={{data: { stroke: '#37e3ba', fill: '#b3ebe0', strokeWidth: 3 }}} />
        <VictoryAxis tickValues={tickValues} tickFormat={tickFormat} fixLabelOverlap={true}
                     style={{grid:{ stroke: '#c0c5c6', strokeDasharray: 5}, axis:{ stroke: '#7c7f7f' }, tickLabels: { fill: '#7c7f7f', fontSize: 14 }}}
                     tickLabelComponent={<VictoryLabel renderInPortal/>}/>
        <VictoryAxis dependentAxis fixLabelOverlap={true}
                     style={{axis:{ stroke: '#7c7f7f' }, tickLabels: { fill: '#7c7f7f', fontSize: 14 }}}
                     tickLabelComponent={<VictoryLabel renderInPortal/>}/>
      </VictoryChart>
    </div>
  )
};



// WEBPACK FOOTER //
// ./src/components/pages/statistics/common/charts/pointsDistribution.js